import { NgFor } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.scss'],
  standalone: true,
  imports: [NgFor, RouterLink],
})
export class PagesComponent implements OnInit {
  readonly routes = [
    '/screens/pages',
    '/screens/landing-page',
    '/screens/components',
    '/account/login',
    '/account/signup',
    '/account/forgot-password',
    '/account/password-reset',
    '/student/course',
    '/student/dashboard',
    '/instructor/courses',
    '/instructor/assignments',
    '/instructor/messages',
    '/instructor/question-answer',
    '/instructor/reports',
    '/instructor/reviews',
  ];

  constructor() {}

  ngOnInit(): void {}
}
